import { AppThunk } from '../../../index';
import { getUserDetailsFailed, getUserDetailsStarted, getUserDetailsSuccess } from '../reducer';
import { UserDocument } from '../../../../models/documents';
import firebase from 'firebase/compat';
import { logOutUser } from './logOutUser';
import { COLLECTION } from '../../../../firestore';

export const getUserDetails =
  (uid: string): AppThunk =>
  async (dispatch, _getState, { db, firestoreSubscriptions, analytics, auth }) => {
    dispatch(getUserDetailsStarted());
    try {
      const ref = db.collection(COLLECTION.USERS).doc(uid);

      if (firestoreSubscriptions.userDetailsListener) {
        firestoreSubscriptions.userDetailsListener();
      }

      let latestIdTokenResult = await auth().currentUser?.getIdTokenResult();
      let previousPermissionsClaimsUpdatedAt: number | null | undefined = undefined;

      firestoreSubscriptions.userDetailsListener = ref.onSnapshot(
        async (snapshot) => {
          const data = snapshot.data() as
            | (UserDocument & {
                createdAt: firebase.firestore.Timestamp;
                updatedAt: firebase.firestore.Timestamp;
                permissionsClaimsUpdatedAt?: firebase.firestore.Timestamp | null;
              })
            | undefined;

          dispatch(
            getUserDetailsSuccess(
              data
                ? {
                    ...data,
                    createdAt: data.createdAt?.toDate(),
                    updatedAt: data.updatedAt?.toDate(),
                    permissionsClaimsUpdatedAt: data.permissionsClaimsUpdatedAt?.toDate() ?? null,
                    systemRole: latestIdTokenResult?.claims?.systemRole || null,
                    isImpersonated: latestIdTokenResult?.claims?.impersonated || false,
                  }
                : undefined
            )
          );

          const claimsUpdatedAtMs = data?.permissionsClaimsUpdatedAt?.toMillis() ?? null;

          if (
            data?.ownerId &&
            previousPermissionsClaimsUpdatedAt !== undefined &&
            claimsUpdatedAtMs !== null &&
            claimsUpdatedAtMs !== previousPermissionsClaimsUpdatedAt
          ) {
            auth()
              .currentUser?.getIdTokenResult(true)
              .then((result) => {
                latestIdTokenResult = result;
              })
              .catch(() => {});
          }

          previousPermissionsClaimsUpdatedAt = claimsUpdatedAtMs;
          if (data) {
            analytics.updateUserProperties(uid, {
              email: data?.email,
              name: data.firstName ? `${data.firstName} ${data.lastName ?? ''}` : undefined,
            });
          }
        },
        () => {
          dispatch(getUserDetailsFailed());
          dispatch(logOutUser());
        }
      );
    } catch (_e) {
      dispatch(getUserDetailsFailed());
    }
  };
